import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Typography, Pagination } from '@mui/material';

import axios from 'axios'
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import Backdrop from '../../../common/components/UI/Backdrop/Backdrop';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import ReactSelect from '../../../common/components/UI/Select/ReactSelect';
import SideBar from '../../../common/components/UI/SideBar/SideBar';
import SimpleDialog from '../../../common/components/UI/Dialog/SimpleDialog';
import SuccesAnimated from '../../../common/components/UI/SuccessAnimated/SuccessAnimated'
import Form from '../Settings/form'
import { TableHeader, TableRow } from '../Table';
import { mapManagerSettings } from '../Table/Table.services';
import * as aux from '../../auxilaries';
import Snackbar from '../../../common/components/UI/Snackbar/Snackbar';
import { currentHttpOptions, formatResponse } from '../../utils'
import { parseHyperfindQueries, rootForV1API } from './archive.service';
import './archive.scss';

const PAGE_SIZE_OPTIONS = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
];

class ManagerDashboardArchive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            sideAction: '',
            displaySpinner: true,
            managerList: [],
            filteredmanagerList: [],
            hyperFindList: [],
            sortBySelected: '',
            sortOrder: 'Ascending',
            showDeleteDialog: false,
            responseStatus: '',
            showResponseDialog: '',
            settingSelected: {},
            responseStatusText: '',
            searchValue: '',
            typeSnackbar: 'success',
            messageSnackbar: '',
            openSnackbar: false,
            timePeriodRatioOptions: [],
            workruleList: [],
            currentPage: 1,
            selectedPageSize: PAGE_SIZE_OPTIONS[1],
        }
        this.init();
    }

    init = async () => {
        const { t } = this.props;

        const options = currentHttpOptions();

        /**
         * @type {[
         *  ApiCommon.GetHyperFindQueriesResponse,
         *  ApiManager.GetArchivedManagerSettingsResponse,
         *  ApiManager.GetManagerSettingsForManagerResponse,
         *  ApiAdmin.GetWorkRuleListResponse,
         *  ApiAdmin.GetTimePeriodListResponse,
         * ]}
         */
        const [hyperFindQuery, managerList, settingsForManager, workruleList, timePeriodRatioOptionsList] = await Promise.all([
            axios.get(`${rootForV1API}/common/GetHyperFindQueries`, options),
            axios.get(`${rootForV1API}/manager/managerSettings/GetArchivedSettings`, options),
            axios.get(`${rootForV1API}/admin/adminSettings/GetSettingsForManager`, options),
            axios.get(`${rootForV1API}/WorkRule/GetWorkRulesList`, options),
            axios.get(`${rootForV1API}/TimePeriodRatio/GetTimePeriodRatioOptions`, options),
        ]);

        const defaultWorkRule = [{ label: 'None (Without work rule)', value: -1, workRuleId: -1 }];

        const tempWorkRuleList = defaultWorkRule.concat(workruleList.data.map(rule => {
            return {
                ...rule,
                label: rule.name,
                value: rule.workRuleId
            };
        }));

        const hyperFindList = parseHyperfindQueries(hyperFindQuery.data);

        const mappedManagerSettings = mapManagerSettings(managerList.data, hyperFindList, t, settingsForManager.data);

        this.setState({
            managerList: mappedManagerSettings,
            filteredmanagerList: mappedManagerSettings,
            hyperFindList,
            settingList: formatResponse(settingsForManager.data, 'id'),
            workruleList: tempWorkRuleList,
            displaySpinner: false,
            timePeriodRatioOptions: timePeriodRatioOptionsList.data.map(option => { return { ...option, checked: false } }),
            currentPage: 1,
        }, () => this.handleSearchFilter());
    }

    handleSubmitForm = (form) => {
        const { t } = this.props
        this.displaySpinner(true);
        const options = currentHttpOptions()

        return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/AddSetting', form, options).then(response => {
            this.setState({
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('settings.successDuplicate'),
                settingSelected: {}
            })

            this.closePanelHandler();
            this.init();
        }).catch(err => {
            let message = aux.handleAPIErrors(err?.response ?? err)
            this.handleSnackbar('error', message, true);
        }).finally(e => {
            this.displaySpinner(false);
            this.closeResponseDialog();
            this.handleSearchFilter();
        })
    }


    handlePageChange = (_event, page) => {
        this.setState({ currentPage: page });
    }

    handlePageSizeChange = (_name, option) => {
        this.setState({ selectedPageSize: option, currentPage: 1 });
    }

    displaySpinner = (displaySpinner) => {
        this.setState({ displaySpinner })
    }

    closePanelHandler = () => {
        this.setState({ openForm: false })
    }

    closeResponseDialog = () => {
        setTimeout(() => {
            this.setState({ showResponseDialog: false })
        }, 3000)
    }

    compareString = (a, b) => {
        var x = a[this.state.sortBySelected].toString();
        var y = b[this.state.sortBySelected].toString();
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    }

    sortBy = (sortIndex) => {
        var oldSortBy = this.state.sortBySelected;
        this.setState({ sortBySelected: sortIndex },
            () => {
                if (oldSortBy === sortIndex) {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ managerList: this.state.managerList.reverse(), sortOrder });
                } else {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ managerList: this.state.managerList.sort(this.compareString), sortOrder });
                }
            }
        )
    }

    cancelAction = () => {
        this.setState({
            openForm: false,
            showDeleteDialog: false,
            sideAction: '',
            spinnerShow: false
        })
    }

    rightPanelHandler = (sideAction, selectedItem) => {
        if (sideAction === 'Delete') {
            this.setState({
                showDeleteDialog: true,
                sideAction,
                settingSelected: selectedItem,
            })
        } else {
            this.setState({
                sideAction,
                settingSelected: selectedItem,
                openForm: true
            })
        }
    }
    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    closeSnackbar = () => {
        setTimeout(() => {
            this.setState({ openSnackbar: false });
        }, 5000)
    }

    deleteItem = async () => {
        const { t } = this.props
        const { settingSelected, managerList } = this.state
        const options = currentHttpOptions()
        let message = ''
        this.displaySpinner(true)
        let deleteAction = await axios.delete(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/DeleteSetting/' + settingSelected.aggregateRootId, options)
            .catch(err => {
                message = aux.handleAPIErrors(err.response)
                this.handleSnackbar('error', message, true)
            }).finally(() => {
                this.displaySpinner(false)
            });


        if (!deleteAction) { //deleteAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        else if (typeof deleteAction.data.error === 'undefined') {
            let managerListAux = managerList.filter((element) => element.aggregateRootId !== settingSelected.aggregateRootId)
            this.setState({
                managerList: managerListAux,
                filteredmanagerList: managerListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('settings.successDelete'),
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof deleteAction.data.error !== 'undefined' ? deleteAction.data.error : deleteAction.data,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
        this.handleSearchFilter()
    }

    handleSearchFilter = (event) => {
        const { searchValue, managerList } = this.state;
        const searchableFields = ['name', 'hyperfindId', 'description', 'details']

        let filteredSettings = [];

        let searchFilter = event === undefined ? searchValue : (event.target.value === undefined) ? searchValue : event.target.value;

        if (searchFilter !== '') {
            for (const setting of managerList) {
                for (const key in setting) {
                    if (searchableFields.includes(key)
                        && setting[key] !== null
                        && setting[key].toString().toLowerCase().includes(searchFilter.toLowerCase())) {
                        filteredSettings.push(setting)
                        break;
                    }
                }
            }
        } else {
            filteredSettings = managerList;
        }

        this.setState({
            searchValue: searchFilter,
            filteredmanagerList: filteredSettings,
            currentPage: 1,
        })
    }

    render() {
        const { t } = this.props;
        const { openForm, sideAction, sortBySelected, sortOrder, displaySpinner, messageSnackbar, openSnackbar, typeSnackbar, filteredmanagerList, showDeleteDialog, searchValue, managerList,
            settingSelected, hyperFindList, settingList, workruleList, showResponseDialog, responseStatus, responseStatusText, timePeriodRatioOptions,
            currentPage, selectedPageSize } = this.state;

        const filteredCount = filteredmanagerList.length;
        const totalPages = Math.ceil(filteredCount / selectedPageSize.value);
        const startIndex = (currentPage - 1) * selectedPageSize.value;
        const paginatedList = filteredmanagerList.slice(startIndex, startIndex + selectedPageSize.value);
        const from = filteredCount === 0 ? 0 : startIndex + 1;
        const to = Math.min(startIndex + selectedPageSize.value, filteredCount);

        let header = (
            <React.Fragment>
                <Grid container>
                    <Grid className="manager-archive-top-buttons" item xs={6} >
                        <SearchInput
                            fullWidth={true}
                            value={searchValue}
                            placeholder={t('settings.search')}
                            onChange={this.handleSearchFilter}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        )
        let success = showResponseDialog ?
            <SuccesAnimated
                type={responseStatus}
                open={showResponseDialog}
                handleClose={() => { this.setState({ showResponseDialog: false }) }}>
                <div className="manager-archive-modal-text">{responseStatusText}</div>
            </SuccesAnimated> : '';

        const deleteContentText = t('settings.deleteContent', { configurationType: t('configurationTypes.request').toLowerCase() });

        return (
            <section>
                <hr className="manager-archive-divider" />
                <div className="manager-archive-content">
                    {header}
                    <div className="manager-archive-table">
                        <TableHeader sortBy={this.sortBy} sortBySelected={sortBySelected} sortOrder={sortOrder} />
                        <div style={{ height: 'calc(100vh - 300px)', minHeight: '300px' }}>
                            <AutoSizer>
                                {({ height, width }) => (
                                    <FixedSizeList
                                        height={height}
                                        width={width}
                                        itemCount={paginatedList.length}
                                        itemSize={50}
                                    >
                                        {({ index, style }) => (
                                            <div style={style}>
                                                <TableRow
                                                    dateFormat={this.props.dateFormat} //TODO 2023/05/05 - kathy - Use user date format set on hris
                                                    showRightPanel={this.rightPanelHandler}
                                                    item={paginatedList[index]}
                                                    index={index}
                                                    hyperFindList={hyperFindList}
                                                    isArchive
                                                />
                                            </div>
                                        )}
                                    </FixedSizeList>
                                )}
                            </AutoSizer>
                        </div>
                    </div>
                    {filteredCount > 0 && (
                            <div className="manager-archive-pagination">
                            <div className="manager-archive-pagination-page-size">
                                <Typography variant="body2" style={{ paddingTop: '8px', marginRight: '8px' }}>
                                    {t('common:tablePagination.rowsPerPage')}:
                                </Typography>
                                <ReactSelect
                                    value={selectedPageSize}
                                    options={PAGE_SIZE_OPTIONS}
                                    onChange={this.handlePageSizeChange}
                                    customStyles={{
                                        control: styles => ({
                                            ...styles,
                                            border: '1px solid #CCCCCC',
                                            minHeight: 25,
                                            height: 25,
                                            minWidth: 80
                                        }),
                                        valueContainer: styles => ({
                                            ...styles,
                                            padding: '0 8px'
                                        }),
                                        singleValue: styles => ({
                                            ...styles,
                                            marginTop: 2
                                        }),
                                        input: styles => ({
                                            ...styles,
                                            margin: 0,
                                            padding: 0
                                        }),
                                        dropdownIndicator: styles => ({
                                            ...styles,
                                            padding: 2
                                        }),
                                        menu: styles => ({
                                            ...styles,
                                            zIndex: 100
                                        })
                                    }}
                                />
                            </div>
                            <Typography variant="body2" style={{ paddingTop: '8px' }}>
                                {t('common:tablePagination.fromToCount', { from, to, count: filteredCount })}
                            </Typography>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={this.handlePageChange}
                                color="primary"
                                size="small"
                                showFirstButton
                                showLastButton
                            />
                        </div>
                    )}
                </div>
                <SideBar
                    className="manager-archive-sidebar"
                    handleDrawerClose={this.closePanelHandler}
                    open={openForm}
                    title={sideAction === 'View' ? t('settings.viewArchivedTitle') : t('settings.setBid')}
                    isCloseOnOutsideClick={false}
                >
                    <Form
                        managerList={managerList}
                        hyperFindList={hyperFindList}
                        settingList={settingList}
                        workruleList={workruleList}
                        settingSelected={settingSelected}
                        cancel={this.cancelAction}
                        handleSubmitForm={this.handleSubmitForm}
                        action={sideAction}
                        timePeriodRatioOptions={timePeriodRatioOptions}
                    />
                </SideBar>
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={this.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                <SimpleDialog
                    open={showDeleteDialog}
                    title={t('settings.delete')}
                    contentText={deleteContentText}
                    submit={this.deleteItem}
                    cancel={this.cancelAction}
                />
                {success}
            </section>
        );
    }
}

export default withTranslation(['employmentBillboard', 'common'])(ManagerDashboardArchive);
